import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { ImageZoomContainer } from '../Styles/Materials';

type ImageZoomProps = {
  imgSrc: string | null;
  onCloseZoom: () => void;
};

const ImageZoom: React.FunctionComponent<ImageZoomProps> = ({
  imgSrc,
  onCloseZoom,
}): React.ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (imgSrc) {
      setIsOpen(true);
    }
  }, [imgSrc]);

  const handleCloseModal = (): void => setIsOpen(false);

  return (
    <ReactModal
      style={{
        content: {
          zIndex: 999999,
        },
        overlay: { zIndex: 99999 },
      }}
      isOpen={isOpen}
      onAfterClose={onCloseZoom}
      onRequestClose={handleCloseModal}
    >
      <ImageZoomContainer
        onClick={handleCloseModal}
        style={{
          backgroundImage: `url(${imgSrc})`,
        }}
      />
    </ReactModal>
  );
};

export default ImageZoom;
